import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_3 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_4 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_7 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_8 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_11 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_12 = { class: "pl-0 pr-2 py-0 ma-0" }
const _hoisted_13 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_14 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_15 = { class: "pl-0 pr-0 py-0 ma-0" }
const _hoisted_16 = { class: "px-2 py-0 ma-0" }
const _hoisted_17 = { class: "pr-2 py-0 ma-0" }
const _hoisted_18 = { class: "py-0 ma-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, {
    style: {"background-color":"transparent"},
    elevation: "0",
    class: "mx-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
        "fixed-tabs": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "1",
            href: "#1",
            style: {"justify-content":"left"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                depressed: "",
                class: "pr-2",
                color: _ctx.step === '1' ? 'primary' : '_grey',
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" 1 ")
                ])),
                _: 1
              }, 8, ["color"]),
              _cache[9] || (_cache[9] = _createTextVNode(" Charges "))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "2",
            href: "#2",
            style: {"justify-content":"left"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                depressed: "",
                class: "pr-2",
                color: _ctx.step === '2' ? 'primary' : '_grey',
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode(" 2 ")
                ])),
                _: 1
              }, 8, ["color"]),
              _cache[11] || (_cache[11] = _createTextVNode(" Activité "))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "3",
            href: "#3",
            style: {"justify-content":"left"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                depressed: "",
                class: "pr-2",
                color: _ctx.step === '3' ? 'primary' : '_grey',
                size: "x-small"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" 3 ")
                ])),
                _: 1
              }, 8, ["color"]),
              _cache[13] || (_cache[13] = _createTextVNode(" Personnel "))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step) = $event)),
        style: {"overflow-y":"auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, {
            value: "1",
            style: {"overflow-y":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                style: {"box-shadow":"none"},
                class: "d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { stye: "overflow-y: auto; height:75vh;" }, {
                    default: _withCtx(() => [
                      (_ctx.formBfaa.charges)
                        ? (_openBlock(), _createBlock(_component_v_data_table, {
                            key: 0,
                            headers: _ctx.dataChargeTableHeader,
                            items: _ctx.formBfaa.charges,
                            itemsPerPage: _ctx.formBfaa.charges.length,
                            "single-expand": false,
                            expanded: _ctx.chargesExpanded,
                            "onUpdate:expanded": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chargesExpanded) = $event)),
                            "item-value": "aaName",
                            "hide-default-footer": "",
                            loading: _ctx.loading,
                            class: "table",
                            density: "compact"
                          }, _createSlots({
                            "expanded-row": _withCtx(({ columns, item }) => [
                              _createElementVNode("td", {
                                colspan: columns.length
                              }, [
                                _createVNode(_component_v_card, {
                                  style: {"box-shadow":"none"},
                                  class: "d-flex flex-column"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { stye: "overflow-y: auto; height:75vh;" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.subLineTableHeadersStaff,
                                          items: item.subLines,
                                          itemsPerPage: item.subLines.length,
                                          "item.key": "companyName",
                                          "hide-default-footer": "",
                                          loading: _ctx.loading,
                                          class: "table",
                                          elevation: "0"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_2, [
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: props.item.toReport,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.toReport) = $event),
                                                  ripple: false,
                                                  onChange: ($event: any) => (
                                                                    _ctx.changeYearlyLineSelection(
                                                                        props.item,
                                                                    )
                                                                )
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                              ]),
                                              _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.companyName), 1),
                                              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    props.item.amountNM1,
                                                                    undefined,
                                                                )), 1)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["headers", "items", "itemsPerPage", "loading"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 8, _hoisted_1)
                            ]),
                            [`item.toReport`]: _withCtx(({ item }) => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: item.toReport,
                                "onUpdate:modelValue": ($event: any) => ((item.toReport) = $event),
                                ripple: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            [`item.variability`]: _withCtx(({ item }) => [
                              _createVNode(_component_v_select_filled, {
                                outlined: "",
                                modelValue: item.variability,
                                "onUpdate:modelValue": ($event: any) => ((item.variability) = $event),
                                items: _ctx.chargeTypes,
                                required: "",
                                "single-line": "",
                                "hide-details": "auto",
                                disabled: !item.toReport,
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled"])
                            ]),
                            [`item.amountNM1`]: _withCtx(({ item }) => [
                              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.amountNM1, undefined)), 1)
                            ]),
                            _: 2
                          }, [
                            (_ctx.chargesGroupingMode === 'TPC')
                              ? {
                                  name: `item.actions`,
                                  fn: _withCtx(({ item }) => [
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps({
                                          onClick: ($event: any) => {
                                                _ctx.mergingSource = item;
                                                _ctx.displayMergeDialog = true;
                                            }
                                        }, props), {
                                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                                            _createTextVNode("$oss-edit")
                                          ])),
                                          _: 2
                                        }, 1040, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Fusionner plusieurs lignes pour synthéthiser le budget généré", -1))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["headers", "items", "itemsPerPage", "expanded", "loading"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, {
            value: "3",
            style: {"overflow-y":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                style: {"box-shadow":"none"},
                class: "d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { stye: "overflow-y: auto; height:75vh;" }, {
                    default: _withCtx(() => [
                      (_ctx.formBfaa.staff)
                        ? (_openBlock(), _createBlock(_component_v_data_table, {
                            key: 0,
                            headers: _ctx.dataTableHeader,
                            items: _ctx.formBfaa.staff,
                            itemsPerPage: _ctx.formBfaa.staff.length,
                            "single-expand": false,
                            expanded: _ctx.staffExpanded,
                            "onUpdate:expanded": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.staffExpanded) = $event)),
                            "item-value": "aaName",
                            "hide-default-footer": "",
                            loading: _ctx.loading,
                            class: "table",
                            density: "compact"
                          }, {
                            "expanded-row": _withCtx(({ columns, item }) => [
                              _createElementVNode("td", {
                                colspan: columns.length
                              }, [
                                _createVNode(_component_v_card, {
                                  style: {"box-shadow":"none"},
                                  class: "d-flex flex-column"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { stye: "overflow-y: auto; height:75vh;" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.subLineTableHeaders,
                                          items: item.subLines,
                                          itemsPerPage: item.subLines.length,
                                          "item.key": "companyName",
                                          "hide-default-footer": "",
                                          loading: _ctx.loading,
                                          class: "table",
                                          elevation: "0"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_6, [
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: props.item.toReport,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.toReport) = $event),
                                                  ripple: false,
                                                  onChange: ($event: any) => (
                                                                    _ctx.changeYearlyLineSelection(
                                                                        props.item,
                                                                    )
                                                                )
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                              ]),
                                              _createElementVNode("td", _hoisted_7, _toDisplayString(props.item.companyName), 1),
                                              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    props.item.amountNM1,
                                                                    undefined,
                                                                )), 1)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["headers", "items", "itemsPerPage", "loading"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 8, _hoisted_5)
                            ]),
                            [`item.toReport`]: _withCtx(({ item }) => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: item.toReport,
                                "onUpdate:modelValue": ($event: any) => ((item.toReport) = $event),
                                ripple: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            [`item.amountNM1`]: _withCtx(({ item }) => [
                              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.amountNM1, undefined)), 1)
                            ]),
                            _: 2
                          }, 1032, ["headers", "items", "itemsPerPage", "expanded", "loading"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, {
            value: "2",
            style: {"overflow-y":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                style: {"box-shadow":"none"},
                class: "d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { stye: "overflow-y: auto; height:75vh;" }, {
                    default: _withCtx(() => [
                      (_ctx.formBfaa.sales)
                        ? (_openBlock(), _createBlock(_component_v_data_table, {
                            key: 0,
                            headers: _ctx.dataTableHeader,
                            items: _ctx.formBfaa.sales,
                            itemsPerPage: _ctx.formBfaa.sales.length,
                            "single-expand": false,
                            expanded: _ctx.salesExpanded,
                            "onUpdate:expanded": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.salesExpanded) = $event)),
                            "item-value": "aaName",
                            "hide-default-footer": "",
                            loading: _ctx.loading,
                            class: "table",
                            density: "compact"
                          }, {
                            "expanded-row": _withCtx(({ columns, item }) => [
                              _createElementVNode("td", {
                                colspan: columns.length
                              }, [
                                _createVNode(_component_v_card, {
                                  style: {"box-shadow":"none"},
                                  class: "d-flex flex-column"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { stye: "overflow-y: auto; height:75vh;" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.subLineTableHeaders,
                                          items: item.subLines,
                                          itemsPerPage: item.subLines.length,
                                          "item.key": "companyName",
                                          "hide-default-footer": "",
                                          loading: _ctx.loading,
                                          class: "table",
                                          elevation: "0"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_10, [
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: props.item.toReport,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.toReport) = $event),
                                                  ripple: false,
                                                  onChange: ($event: any) => (
                                                                    _ctx.changeYearlyLineSelection(
                                                                        props.item,
                                                                    )
                                                                )
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                              ]),
                                              _createElementVNode("td", _hoisted_11, _toDisplayString(props.item.companyName), 1),
                                              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    props.item.amountNM1,
                                                                    undefined,
                                                                )), 1)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["headers", "items", "itemsPerPage", "loading"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 8, _hoisted_9)
                            ]),
                            [`item.toReport`]: _withCtx(({ item }) => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: item.toReport,
                                "onUpdate:modelValue": ($event: any) => ((item.toReport) = $event),
                                ripple: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["headers", "items", "itemsPerPage", "expanded", "loading"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.displayMergeDialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.displayMergeDialog) = $event)),
        onValid: _ctx.mergeSelectedLines,
        validTitle: "Fusionner les lignes sélectionnées"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            style: {"box-shadow":"none"},
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode(" Fusion de lignes ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_card_text, { style: {"height":"75vh"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tabs, {
                    modelValue: _ctx.stepMergeDialog,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.stepMergeDialog) = $event)),
                    "fixed-tabs": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, {
                        value: "1",
                        href: "#1",
                        style: {"justify-content":"left"}
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode(" Lignes recommandées ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_tab, {
                        value: "2",
                        href: "#2",
                        style: {"justify-content":"left"}
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode(" Toutes les lignes ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_tabs_window, {
                        modelValue: _ctx.stepMergeDialog,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stepMergeDialog) = $event)),
                        style: {"overflow-y":"auto"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, {
                            value: "1",
                            style: {"overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                style: {"box-shadow":"none"},
                                class: "d-flex flex-column"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, { style: {"height":"75vh"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_data_table, {
                                        items: _ctx.recommandedCharges,
                                        headers: _ctx.mergeHeaders,
                                        itemsPerPage: _ctx.recommandedCharges.length,
                                        "hide-default-footer": "",
                                        class: "table"
                                      }, {
                                        item: _withCtx((props) => [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("td", _hoisted_13, [
                                              _createVNode(_component_v_checkbox, {
                                                modelValue: props.item.toMerge,
                                                "onUpdate:modelValue": ($event: any) => ((props.item.toMerge) = $event),
                                                ripple: false
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("td", _hoisted_14, [
                                              _createVNode(_component_v_text_field_filled, {
                                                modelValue: props.item.company,
                                                "onUpdate:modelValue": ($event: any) => ((props.item.company) = $event),
                                                outlined: "",
                                                density: "compact"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("td", _hoisted_15, _toDisplayString(props.item.amount), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["items", "headers", "itemsPerPage"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, {
                            value: "2",
                            style: {"overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                style: {"box-shadow":"none"},
                                class: "d-flex flex-column"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, { style: {"height":"75vh"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_data_table, {
                                        items: _ctx.allCharges,
                                        headers: _ctx.mergeHeaders,
                                        itemsPerPage: _ctx.allCharges.length,
                                        "hide-default-footer": "",
                                        class: "table"
                                      }, {
                                        item: _withCtx((props) => [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("td", _hoisted_16, [
                                              _createVNode(_component_v_checkbox, {
                                                modelValue: props.item.toMerge,
                                                "onUpdate:modelValue": ($event: any) => ((props.item.toMerge) = $event),
                                                ripple: false
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("td", _hoisted_17, _toDisplayString(props.item.company), 1),
                                            _createElementVNode("td", _hoisted_18, _toDisplayString(props.item.amount), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["items", "headers", "itemsPerPage"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"])
    ]),
    _: 1
  }))
}